export const checkForIos = () => {
	var userAgent = navigator.userAgent || navigator.vendor || window.opera;
	return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
};

export const checkForIpad = () => {
	var userAgent = navigator.userAgent || navigator.vendor || window.opera;
	return /iPad/.test(userAgent) && !window.MSStream;
};



// WEBPACK FOOTER //
// ./utils/checkForIos.js